import { createBrowserRouter, Navigate } from 'react-router-dom'
import type { ComponentType } from 'react'
import { AppShell } from '@/components/domain/app-shell'
import { AppErrorBoundary } from './error-boundary'

const lazyPage = (loader: () => Promise<{ default: ComponentType }>) => ({ lazy: async () => ({ Component: (await loader()).default }) })
const hydrateFallbackElement = <div className="grid min-h-screen place-items-center bg-background text-sm text-muted-foreground">正在载入研究工作台…</div>

export const router = createBrowserRouter([
  { path: '/', element: <AppShell />, hydrateFallbackElement, errorElement: <AppErrorBoundary><Navigate to="/" replace /></AppErrorBoundary>, children: [
    { path: 'research', element: <Navigate to="/strategies" replace /> },
    { index: true, ...lazyPage(() => import('@/routes/overview')) },
    { path: 'strategies', ...lazyPage(() => import('@/routes/strategies')) },
    { path: 'strategies/:templateKey', ...lazyPage(() => import('@/routes/strategies')) },
    { path: 'data', ...lazyPage(() => import('@/routes/data')) },
    { path: 'data/datasets/:datasetId', ...lazyPage(() => import('@/routes/dataset-detail')) },
    { path: 'stocks', ...lazyPage(() => import('@/routes/stocks')) },
    { path: 'stocks/:symbol', ...lazyPage(() => import('@/routes/stock-detail')) },
    { path: 'research/screener', ...lazyPage(() => import('@/routes/research-screener')) },
    { path: 'research/pools', ...lazyPage(() => import('@/routes/research-pools')) },
    { path: 'research/pools/:poolId', ...lazyPage(() => import('@/routes/research-pools')) },
    { path: 'research/factors', ...lazyPage(() => import('@/routes/research-factors')) },
    { path: 'research/events', ...lazyPage(() => import('@/routes/research-events')) },
    { path: 'research/runs/:runId', ...lazyPage(() => import('@/routes/research-run')) },
    { path: 'research/daily-screens/:screenId', ...lazyPage(() => import('@/routes/daily-screen-detail')) },
    { path: 'backtests', ...lazyPage(() => import('@/routes/backtests')) },
    { path: 'backtests/new', ...lazyPage(() => import('@/routes/backtest-new')) },
    { path: 'backtests/portfolio/:runId', ...lazyPage(() => import('@/routes/portfolio-backtest-detail')) },
    { path: 'backtests/:runId', ...lazyPage(() => import('@/routes/backtest-detail')) },
    { path: 'diagnostic-backtests/:batchId', ...lazyPage(() => import('@/routes/diagnostic-backtest-detail')) },
    { path: 'paper', ...lazyPage(() => import('@/routes/paper')) },
    { path: 'paper/strategy-runs/:runId', ...lazyPage(() => import('@/routes/paper-strategy-run')) },
    { path: 'execution', element: <Navigate to="/paper" replace /> },
    { path: 'paper/:accountId', ...lazyPage(() => import('@/routes/paper-account')) },
    { path: 'risk', ...lazyPage(() => import('@/routes/risk')) },
    { path: 'jobs', ...lazyPage(() => import('@/routes/jobs')) },
    { path: 'settings', ...lazyPage(() => import('@/routes/settings')) },
    { path: '*', ...lazyPage(() => import('@/routes/not-found')) },
  ] },
  { path: '/login', hydrateFallbackElement, ...lazyPage(() => import('@/routes/login')) },
])
